import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:상품등록 > 사이즈 관리
 * 세부설명:
*/

export class SizeReg extends Component {
    static displayName = SizeReg.name;

    constructor(props) {
        super(props);
        this.state = {
            Title:""
        };
        this.handleSizeGrp_Clik = this.handleSizeGrp_Clik.bind(this);
        this.handleSize_Clik = this.handleSize_Clik.bind(this);
        this.handleSelect_Click = this.handleSelect_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        this.SizeGrpDataCall();
    }
    GoodsDataSetProp = {
        CategoryModel: "",  //카테고리 분류코드
        SizGrpModel: [],    //사이즈 구룹
        SizMgtModel: [],    //사이즈 코드 리스트
        Sizgrp_Cd: "",      //선택한 사이즈 그룹 코드
        GoodsSizModel: [],  //사이즈 모델(DB)
        GoodsSizInfo: null  //사이즈 모델 속성(DB)
    }
    //사이즈 그룹 클릭
    handleSizeGrp_Clik(event, SizgrpCd) {
        document.querySelectorAll(".large_Category > .category_item").forEach((sizeElement) => {
            if (sizeElement.id === SizgrpCd) {
                sizeElement.className = "category_item col select";
                this.GoodsDataSetProp.Sizgrp_Cd = SizgrpCd;
                this.SizeMgtDataCall(SizgrpCd);
            }
            else {
                sizeElement.className = "category_item col";
            }
        });
        event.preventDefault();
    }
    //사이즈 클릭
    handleSize_Clik(event, SizCd, SizNm) {
        document.querySelectorAll(".small_Category > .category_item").forEach((sizeElement) => {
            if (sizeElement.id === SizCd) {
                if (sizeElement.className === "category_item col") {
                    sizeElement.className = "category_item col select"; 

                    let goodssizinfo = Big3Common.Util.Cloen(this.GoodsDataSetProp.GoodsSizInfo);
                    goodssizinfo.Sizgrp_Cd = this.GoodsDataSetProp.Sizgrp_Cd;
                    goodssizinfo.Siz_Cd = SizCd;
                    goodssizinfo.Siz_Nm = SizNm;
                    this.GoodsDataSetProp.GoodsSizModel.push(goodssizinfo);

                }
                else {
                    sizeElement.className = "category_item col";
                    //선택된 항목 삭제
                    Big3Common.Util.RemoveModelListRow(this.GoodsDataSetProp.GoodsSizModel, "Siz_Cd", SizCd);
                }
            }
            
        });
        event.preventDefault();
    }
    handleSelect_Click(event) {
        if (this.GoodsDataSetProp.GoodsSizModel.length === 0) {
            this.setState({ Title: "사이즈를 선택하여 주세요." });
            Big3Common.ModalAlert(bootstrap, 'SizeRegAlert');
            return false;
        }
        let ContentState = this.props.ContentState;
        ContentState.GoodsSizModel = this.GoodsDataSetProp.GoodsSizModel;
        this.props.RenderComponent('GoodsReg', ContentState);
        event.preventDefault();
    }
    //사이즈 그룹 조회
    async SizeGrpDataCall() {
        try {
            
            if (this.props.ContentState !== undefined)
            {
                this.GoodsDataSetProp.CategoryModel = this.props.ContentState.CategoryModel;
                this.GoodsDataSetProp.GoodsSizInfo = Big3Common.Util.Cloen(this.props.ContentState.GoodsSizInfo);
                //카테고리 대분류 
                let ManCd = this.GoodsDataSetProp.CategoryModel.Man_Cd;
                let MidCd = this.GoodsDataSetProp.CategoryModel.Mid_Cd;
                let Data = await Big3Common.Get(`api/Common/BaseCode/GetSizgrp/${ManCd}/${MidCd}`);
                if (Data.codeName === Big3Common.ResultCode.Success) {
                    let sizeGrp = JSON.parse(Data.dataTable);
                    this.GoodsDataSetProp.SizGrpModel = sizeGrp;
                    this.forceUpdate();
                }
                else {
                    console.log("등록된 사이즈 구룹이 없습니다.");
                }
            }
        }
        catch (e) {
            console.log("SizeGrpDataCall: ", e)
        }
        return false;
    } 
    //사이즈 코드조회
    async SizeMgtDataCall(SizgrpCd) {
        try {

            //선택된 사이즈 항목 초기화
            this.GoodsDataSetProp.GoodsSizModel = [];
            document.querySelectorAll(".small_Category > .category_item").forEach((sizeElement) => {
                sizeElement.className = "category_item col";
            });

            let Data = await Big3Common.Get(`api/Common/BaseCode/GetSizmgt/${SizgrpCd}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let sizeMgt = JSON.parse(Data.dataTable);
                this.GoodsDataSetProp.SizMgtModel = sizeMgt;
                this.forceUpdate();
            }
            else {
                console.log("등록된 사이즈가 없습니다.");
            }
        }
        catch (e) {
            console.log("SizeMgtDataCall: ", e)
        }
        return false;
    } 
    //사이즈 구룹
    SizeGrprender() {
        let ListData = this.GoodsDataSetProp.SizGrpModel;
        return (
            <div className="category_select large_Category row row-cols-2" >
                {ListData.map(list =>
                    <div className="category_item col"
                        key={list.sizgrp_cd}
                        id={list.sizgrp_cd}
                        onClick={(e) => this.handleSizeGrp_Clik(e,list.sizgrp_cd)}>{list.sizgrp_nm}
                    </div>
                )}
            </div>
        )
    }
    //사이즈
    SizeMgtrender() {
        let ListData = this.GoodsDataSetProp.SizMgtModel;
        return (
            <div className="category_select small_Category row row-cols-2">
                {ListData.map(list =>
                    <div className="category_item col"
                        key={list.siz_cd}
                        id={list.siz_cd}
                        onClick={(e) => this.handleSize_Clik(e, list.siz_cd, list.siz_nm)}>{list.siz_nm}
                    </div>
                )}
            </div>
        )
    }
    render() {
        let SizeGrprender = this.SizeGrprender();
        let SizeMgtrender = this.SizeMgtrender();
        return (
            <div>
                <div className="Material_wrap">
                    <div className="category_slectbox">
                        <div className="title">사이즈 그룹 선택</div>
                        {SizeGrprender}
                    </div>
                    <div className="category_slectbox">
                        <div className="title">사이즈</div>
                        {SizeMgtrender }
                    </div>
                </div >
                <div className="catagory_button_box">
                    <button type="button" className="btn_v btn_v1" onClick={this.handleSelect_Click }>확인</button>
                </div>  
                <Alert
                    id="SizeRegAlert"
                    title={this.state.Title}
                />
            </div>
        );
    }
}
